interface IStepItem {
    title:string;
    description:string;
}
interface Props {
    steps: IStepItem[];
    activeStep: number;
}
function MobileFormStepper({steps, activeStep}:Props) {
  return (
    <div className="bg-white py-3 rounded-md mb-2 px-5 w-full md:hidden">
        <div className="w-full flex justify-between items-center">
            <div className="w-11 h-11 rounded-full border-2 border-slate-400 flex items-center justify-center text-xs">
                {activeStep + 1} of {steps.length}
            </div>
            <div className="flex flex-col items-end">
                <p className="font-semibold text-[20px]">{steps[activeStep].title}</p>
                {activeStep < steps.length-1 && <p className="text-[14px] text-web_primary opacity-50">Next: {steps[activeStep+1].title}</p>}
            </div>
        </div>
        
    </div>
  )
}

export default MobileFormStepper;
